// A money amount typed into a text field: digits with at most two decimals, comma or point. A
// half-typed value («12.») passes, so it gates onChange.
export const AMOUNT_INPUT_PATTERN = /^\d*([.,]\d{0,2})?$/

// The typed amount as a number; null while nothing parseable is typed — empty or a lone separator.
export const parseAmountInput = (value: string): number | null => {
  const amount = Number(value.replace(',', '.'))

  return value === '' || Number.isNaN(amount) ? null : amount
}
